// Import domain queries
import { branchQueries } from './branch';
import { lookupQueries } from './lookup';
import { tenantQueries } from './tenant';
import { purchaseOrderQueries } from './purchaseOrder';

// Re-export types
export * from './branch';
export * from './lookup';
export * from './purchaseOrder';

// Export all shared queries
export const sharedQueries = {
  branch: branchQueries,
  lookup: lookupQueries,
  tenant: tenantQueries,
  purchaseOrder: purchaseOrderQueries,
}; 